import ReactDOM from "react-dom/client";

export default function showModal(message, { type = "info" } = {}) {
  return new Promise((resolve) => {
    const modal = document.createElement("div");
    document.body.appendChild(modal);

    const root = ReactDOM.createRoot(modal);

    const close = (result) => {
      root.unmount();
      modal.remove();
      resolve(result);
    };

    const confirmType = type === "confirm";

    root.render(
      <div style={styles.backdrop}>
        <div style={styles.modal}>
          <p style={{ whiteSpace: "pre-wrap" }}>{message}</p>
          <div style={styles.actions}>
            {confirmType ? (
              <>
                <button onClick={() => close(true)} style={styles.confirm}>OK</button>
                <button onClick={() => close(false)} style={styles.cancel}>Anuluj</button>
              </>
            ) : (
              <button onClick={() => close(true)} style={styles.confirm}>Zamknij</button>
            )}
          </div>
        </div>
      </div>
    );
  });
}

const styles = {
  backdrop: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.4)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
  modal: {
    background: "white",
    padding: "1.5rem",
    borderRadius: "8px",
    maxWidth: "90%",
    width: "400px",
    boxShadow: "0 5px 15px rgba(0,0,0,0.2)",
  },
  actions: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "1rem",
    gap: "0.5rem",
  },
  confirm: {
    backgroundColor: "#007bff",
    color: "white",
    border: "none",
    padding: "8px 14px",
    borderRadius: "6px",
    cursor: "pointer",
  },
  cancel: {
    backgroundColor: "#ccc",
    color: "black",
    border: "none",
    padding: "8px 14px",
    borderRadius: "6px",
    cursor: "pointer",
  },
};
